import { rem } from 'polished';
import styled from 'styled-components';

import { bokehTheme as theme } from '@vimeo/bokeh-theme';
import { ChevronDown } from '@vimeo/iris/icons';

const ChevronIcon = styled(ChevronDown)`
  width: ${rem(16)};
  height: ${rem(16)};
  margin-top: ${rem(2)};
  &:hover {
    path {
      fill: ${theme.colors.gray['800'] as string};
    }
  }
  path {
    fill: ${theme.colors.gray['200'] as string};
  }
`;

export default ChevronIcon;
